import { render } from "./FoodItem.vue?vue&type=template&id=14f7f24e&scoped=true"
import script from "./FoodItem.vue?vue&type=script&lang=js"
export * from "./FoodItem.vue?vue&type=script&lang=js"

import "./FoodItem.vue?vue&type=style&index=0&id=14f7f24e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f7f24e"]])

export default __exports__